import Dialog from 'material-ui/Dialog';
import * as React from 'react';
import { CustomButton } from '../reusableComponents/CustomButton';
import { TextInput } from '../reusableComponents/FormComponents/TextInput';
import { Icon } from '../reusableComponents/Icon';
import { PerfectScrollbar } from '../reusableComponents/PerfectScrollbar';
import './modules.scss';
import { ILinkProps } from 'src/model/ModuleModel';
// import { IExtProps } from 'src/model/ModuleModel';
import { FILESALLOWEDEXE, FILESALLOWEDEXTENSION } from 'src/constants/generals';

import { showAlert } from 'src/actions/miscellaneousActions';

export interface IFileInputComponentProps {
    defaultValue?: ILinkProps[];
    Extensions?: any;
    AcceptFileType?: any;
}

export interface IURLProps {
    link: string;
    title: string;
}

export interface IFileProps {
    fileName: string;
    file: File;
}

export interface IFileInputComponentState {
    files: IFileProps[];
    urls: IURLProps[];
    title: string;
    addURL: boolean;
    open: boolean;
    activeEditURLTitle: string;
    urlValue: string;
}

export class FileInputComponent extends React.Component<IFileInputComponentProps, IFileInputComponentState> {
    constructor(props: IFileInputComponentProps) {
        super(props);
        this.state = {
            files: [],
            urls: props.defaultValue || [],
            addURL: false,
            urlValue: '',
            title: '',
            open: false,
            activeEditURLTitle: '',
        };
    }

    get fileAndURLs() {
        return {
            files: this.state.files,
            urls: this.state.urls
        };
    }

    public renderFiles = () => {
        const { files } = this.state;
        return (files.length > 0 ? files.map((file, index) => {
            return <div key={index} className="file">
                <Icon icon="file" size="2x" />
                <span className="file-name" >{file.fileName}</span>
                <Icon icon="trash" onClick={() => this.handleURLDelete(file.fileName)} />
            </div>;
        }) : 'No Files Selected');
    }

    public handleURLDelete = (fileName: string) => {
        const files = this.state.files.filter((file) => file.fileName !== fileName);
        this.setState({
            files
        });
    }

    public renderLinks = () => {
        const { urls } = this.state;
        return (urls.length > 0 ? urls.map((url, index) => {
            return <div key={index} className="file">
                <Icon icon="link" size="2x" />
                <div className="file-name" >{url.title}</div>
                <div className="options">
                    <Icon icon="pencil-alt" onClick={() => this.handleURLEdit(url)} />
                    <Icon icon="trash" onClick={() => this.handleLinkDelete(url.title)} />
                </div>
            </div>;
        }) : 'No Links Added');
    }

    public handleLinkDelete = (title: string) => {
        const urls = this.state.urls.filter((url) => url.title !== title);
        this.setState({
            urls
        });
    }

    public handleURLEdit = (url: IURLProps) => {
        this.setState({
            open: true,
            title: url.title,
            urlValue: url.link,
            activeEditURLTitle: url.title
        });
    }

    public handleFileChange = (e) => {
        const files = e.target.files;
        const UploadError = '';
        const filesArray = this.state.files.length > 0 ? this.state.files : [];
        const fileType = ['image/', 'video/', 'application/'];
        const Ext = this.props.Extensions;
        let invalid = 0;
        for (let i = 0; i < files.length; i++) {
            const fileContent = files[i].name.split('.'); 
            if (this.props.Extensions !== undefined) {
                if (Ext.indexOf(fileContent[fileContent.length - 1].toLowerCase()) === -1) {
                    invalid++; 
                } else {
                    filesArray.push({
                        fileName: files[i].name,
                        file: files[i]
                    });
                }
            } else {
                filesArray.push({
                    fileName: files[i].name,
                    file: files[i]
                });
            }
        }
        if (invalid > 0) {  
            showAlert({
                title: 'Oops..!!',
                text: `Only ${Ext.join(', ')} files allowed. ${invalid} file(s) CANNOT be upload.`,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
            // return;
        }
        this.setState({
            files: filesArray
        });
    }

    public handleClickOnAddLinks = () => {
        const urls = this.state.urls;
        if (this.state.activeEditURLTitle) {
            const newURLs = urls.filter((url) => url.title !== this.state.activeEditURLTitle);
            newURLs.push({
                link: this.state.urlValue,
                title: this.state.title,
            });
            this.setState({
                addURL: this.state.urlValue.length <= 0,
                urls: newURLs,
                open: false,
                activeEditURLTitle: '',
                urlValue: '',
                title: ''
            });
            return;
        }
        urls.push({
            link: this.state.urlValue,
            title: this.state.title,
        });
        this.setState({
            addURL: this.state.urlValue.length <= 0,
            urls,
            open: false,
            activeEditURLTitle: '',
            urlValue: '',
            title: ''
        });
    }

    public renderButtons = () => {
        return <div className="input-field">
            <div className="file-input-container">
                <div className="file-input-upload">
                    <div><Icon icon="upload" /></div>

                    <div><label htmlFor="fileInput">Select File(s)</label></div>
                    <input multiple onChange={this.handleFileChange} accept={this.props.AcceptFileType ? this.props.AcceptFileType.join(', ') : ''}  type="file" id="fileInput" />
                </div>
                <span className="or" >OR</span>
                <div className="file-input-upload" onClick={this.handleOpen}>
                {/* <CustomButton icon="link" onClick={this.handleOpen} type="button"  >Add Link(s)</CustomButton> */}
                    <div><Icon icon="link" /></div>
                    <div><label htmlFor="">Add Link(s)</label></div>
                </div>
            </div>
        </div>;
    }

    public renderInput = () => {
        return <div className="input-field url-input" >
            <TextInput
                hintText="Enter Title for the URL..."
                id="link"
                type="text"
                onChange={(e, value) => this.setState({
                    title: value
                })}
                value={this.state.title}
            />
            <TextInput
                hintText="Paste your URL/Link here..."
                id="link"
                type="text"
                onChange={(e, value) => this.setState({
                    urlValue: value
                })}
                value={this.state.urlValue}
            />
            <div className="buttons">
                <CustomButton icon="plus" onClick={this.handleClickOnAddLinks} type="button"  >Add</CustomButton>
                <span style={{ padding: '0px 10px' }} />
                <CustomButton icon="ban" 
                onClick={() => this.setState({ open: false })} type="button"  >Cancel</CustomButton>
            </div>
        </div >;
    }

    public handleOpen = () => {
        this.setState({ open: true });
    }

    public handleClose = () => {
        this.setState({ open: false });
    }

    public render() {
        return <div className="file-input-component" >
            <Dialog
                title="Add URL/Link"
                modal={false}
                className="url-modal"
                open={this.state.open}
                onRequestClose={this.handleClose}
            >
                {this.renderInput()}
            </Dialog>
            <div className="text-input file-input" >
                <div className="input-label" style={{ width: '40%' }} >
                    <label htmlFor="" >Upload File(s)/Add Link(s)</label>
                </div>
                {this.renderButtons()}
            </div>
            {this.props.AcceptFileType ?
                <div>
                <p className="FileFormatType">*Only {this.props.Extensions.join(', ')} is allowed.</p>
                </div> : ''
            }
            {this.state.files.length > 0 || this.state.urls.length > 0 ?
                <div className="onboarding-docs" >
                    <PerfectScrollbar className="links" >
                        {this.renderLinks()}
                    </PerfectScrollbar>
                    <PerfectScrollbar className="files" >
                        {this.renderFiles()}
                    </PerfectScrollbar>
                </div> : ''}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/FileInputComponent.tsx